<template>
  <div
    class="editorial-full-gallery"
    :class="{
      'row-1': !content.fullscreen.includes('si'),
    }"
    v-anim-parallax-element="{
      target: 'picture',
      offset: 10,
    }"
  >
    <WidgetSliderFullWidthSwiper :slides="slides" />
  </div>
</template>

<script>
export default {
  name: 'EditorialFullGallery',
}
</script>

<script setup>
const props = defineProps({
  content: Object,
})

const slides = computed(() => {
  const slides = props.content.gallery.map((galleryItem) => {
    let landscape = props.content.landscape.find(
      (landscapeItem) => landscapeItem.id === galleryItem.id
    )
    let portrait = props.content.portrait.find(
      (portraitItem) => portraitItem.id === galleryItem.id
    )

    return {
      landscape,
      portrait,
      title: galleryItem.title,
    }
  })
  return slides
})
</script>
